import React from 'react'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps'
import { compose, withProps } from 'recompose'


const Map = compose(
  withProps({
    googleMapURL:
      'https://maps.googleapis.com/maps/api/js?key=' + process.env.REACT_APP_MAPKEY + '&v=3.exp&libraries=geometry,drawing,places',
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `300px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap,
)((props) => (
  <>
    <GoogleMap
      options={{ scrollwheel: false }}
      defaultZoom={16}
      defaultCenter={{
        lat: props.experience.locator.geometry.lat,
        lng: props.experience.locator.geometry.lng,
      }}
      drawingControl={true}
    >
      <Marker
        position={{
          lat: props.experience.locator.geometry.lat,
          lng: props.experience.locator.geometry.lng,
        }}
      />
    </GoogleMap>

  </>
))

export default Map
